import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { MailCommon } from 'src/app/core/constants/mail-box-const';
import { AuthenticationService } from 'src/app/core/services/auth/authentication.service';
import { LoaderService } from 'src/app/core/services/loader/loader.service';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { UserListModalComponent } from '../user-list-modal/user-list-modal.component';
import { UsersService } from 'src/app/core/services/users/users.service';
import { CookieService } from 'src/app/core/services/cookie/cookie.service';

@Component({
  selector: 'app-switch-user-list',
  templateUrl: './switch-user-list.component.html',
  styleUrls: ['./switch-user-list.component.scss']
})
export class SwitchUserListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() exitToMainProfile: boolean = false;
  isActiveSwitchUser: boolean = false;
  accessAcountList: any = []
  private _unsubscribeAll: Subject<any> = new Subject();

  constructor(private _lc: LocalStorageService, private router: Router, private _authService: AuthenticationService, private _loaderService: LoaderService, private modal: MatDialog, private _userService: UsersService, private _cookeService: CookieService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['exitToMainProfile']?.currentValue) {
      this.backToMainProfile();
    }
  }

  ngOnInit(): void {
    this.isActiveSwitchUser = !this._lc.getSwitchedUserDetails();
    if (this._lc.getKey('accountAccess')) {
      const accessAcountList = JSON.parse(this._lc.getKey('accountAccess'));
      this.getuserDetails(accessAcountList)
    }
  }

  getuserDetails(accessAcountList) {
    this.accessAcountList = accessAcountList.map((item) => item?.userId)?.join(',');
  }

  switchUser(account) {
    const userDetails = this._authService.getLoginUserDetails();
    const payload = {
      userId: userDetails?.id,
      switchUserId: account?.userId
    }
    this._loaderService.showLoader();
    this._authService.switchLogin(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe({
      next: (res) => {
        this._loaderService.hideLoader();
        if (res?.statusCode === 200 && res?.data) {
          const data = {
            roles_permissions: res?.data?.roles,
            user_details: res?.data,
            refreshToken: res?.data?.refreshToken,
          }
          this._lc.removeKey(MailCommon.selected_domain)
          this._lc.setSwitchedUserDetails(data);
          this._cookeService.setCookie('sw_ref_token', data?.refreshToken);
          this.router.navigateByUrl('/').then(() => {
            location.reload();
          });

        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
        this._loaderService.hideLoader();
      }
    })

  }

  backToMainProfile() {
    this._lc.removeSwitchedUserDetails();
    this.router.navigateByUrl('/').then(() => {
      location.reload();
    });
  }

  showAccessUserModal() {
    const dialogRef = this.modal.open(UserListModalComponent, {
      width: '700px',
      maxWidth: '95vh',
      enterAnimationDuration: '300ms',
      exitAnimationDuration: '100ms',
      panelClass: 'access-user-list',
      data: {
        accessAcounIds: this.accessAcountList,
      }
    })
    dialogRef.afterClosed().subscribe({
      next: (account) => {
        if (account) {
          this.switchUser(account);
        }
      }
    })
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }
} 
